import { Capacitor } from '@capacitor/core';
import { getMobileOperatingSystem } from '../api/constants';

export const isIOS = () => {
  if (Capacitor.isNativePlatform()) {
    return Capacitor.getPlatform() === "ios";
  }
  return getMobileOperatingSystem() === "ios";
};

export const isAndroid = () => {
  if (Capacitor.isNativePlatform()) {
    return Capacitor.getPlatform() === "android";
  }
  return getMobileOperatingSystem() === "android";
};

export const isNative = () => {
  return Capacitor.isNativePlatform();
};

export const getPlatform = () => {
  if (Capacitor.isNativePlatform()) {
    return Capacitor.getPlatform();
  }
  return getMobileOperatingSystem();
};
